// extracted by mini-css-extract-plugin
export default {"leftContainer":"base_leftContainer__L-5xq","pageSlider":"base_pageSlider__tT1AE","submitBtn":"base_submitBtn__xVnoP","back":"base_back__l9RBE"};